export function clampNumber(n: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, n));
}

export function getTotalPages(itemsCount: number, pageSize: number): number {
  return Math.max(1, Math.ceil(itemsCount / pageSize));
}

export function getPageSlice<T>(items: T[], pageIndex: number, pageSize: number): T[] {
  const start = pageIndex * pageSize;
  return items.slice(start, start + pageSize);
}
